import type { ThinClient } from './types';

export const mockThinClients: ThinClient[] = [
  {
    id: 'TC001',
    alias: '会议室-01',
    serialNumber: 'SN20240001',
    status: 'enabled',
    venue: '北京总部办公区',
    venueId: 'VEN001',
    tenant: '科技有限公司',
    tenantId: 'TEN001',
    macWireless: '00:1A:2B:3C:4D:5E',
    macWired: '00:1A:2B:3C:4D:5F',
    lastBootTime: '2024-01-25 08:30:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-10 14:30:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-20 16:45:00',
    updatedBy: '李运维',
    currentUser: '张三',
    lastUser: '李四',
    currentHost: {
      id: 'PC001',
      name: '云电脑-001'
    }
  },
  {
    id: 'TC002',
    alias: '工位-A01',
    serialNumber: 'SN20240002',
    status: 'enabled',
    venue: '北京总部办公区',
    venueId: 'VEN001',
    tenant: '科技有限公司',
    tenantId: 'TEN001',
    macWireless: '00:1A:2B:3C:4D:60',
    macWired: '00:1A:2B:3C:4D:61',
    lastBootTime: '2024-01-25 08:35:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-10 14:35:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-20 16:50:00',
    updatedBy: '李运维',
    lastUser: '王五'
  },
  {
    id: 'TC003',
    alias: '工位-A02',
    serialNumber: 'SN20240003',
    status: 'enabled',
    venue: '北京总部办公区',
    venueId: 'VEN001',
    tenant: '科技有限公司',
    tenantId: 'TEN001',
    macWireless: '00:1A:2B:3C:4D:62',
    macWired: '00:1A:2B:3C:4D:63',
    lastBootTime: '2024-01-25 08:32:00',
    firmwareVersion: 'v2.3.0',
    createdAt: '2024-01-10 14:40:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-20 16:55:00',
    updatedBy: '李运维',
    currentUser: '赵六',
    currentHost: {
      id: 'PC002',
      name: '云电脑-002'
    }
  },
  {
    id: 'TC004',
    alias: '前台接待',
    serialNumber: 'SN20240004',
    status: 'enabled',
    venue: '上海分公司',
    venueId: 'VEN002',
    tenant: '互联网科技',
    tenantId: 'TEN002',
    macWireless: '00:1A:2B:3C:4D:64',
    macWired: '00:1A:2B:3C:4D:65',
    lastBootTime: '2024-01-25 07:45:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-28 11:20:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-05 14:30:00',
    updatedBy: '赵运维',
    currentUser: '孙七',
    lastUser: '周八',
    currentHost: {
      id: 'PC003',
      name: '云电脑-003'
    }
  },
  {
    id: 'TC005',
    alias: '工位-B01',
    serialNumber: 'SN20240005',
    status: 'disabled',
    venue: '上海分公司',
    venueId: 'VEN002',
    tenant: '互联网科技',
    tenantId: 'TEN002',
    macWireless: '00:1A:2B:3C:4D:66',
    macWired: '00:1A:2B:3C:4D:67',
    lastBootTime: '2024-01-25 08:00:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-28 11:25:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-05 14:35:00',
    updatedBy: '赵运维',
    lastUser: '吴九'
  },
  {
    id: 'TC006',
    alias: '研发-01',
    serialNumber: 'SN20240006',
    status: 'enabled',
    venue: '深圳研发中心',
    venueId: 'VEN003',
    tenant: '科技有限公司',
    tenantId: 'TEN001',
    macWireless: '00:1A:2B:3C:4D:68',
    macWired: '00:1A:2B:3C:4D:69',
    lastBootTime: '2024-01-25 08:15:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-15 10:00:00',
    createdBy: '张管理员',
    updatedAt: '2024-01-22 15:20:00',
    updatedBy: '李运维',
    currentUser: '郑十',
    currentHost: {
      id: 'PC004',
      name: '云电脑-004'
    }
  },
  {
    id: 'TC007',
    alias: '工位-C01',
    serialNumber: 'SN20240007',
    status: 'enabled',
    venue: '成都分公司',
    venueId: 'VEN005',
    tenant: '互联网科技',
    tenantId: 'TEN002',
    macWireless: '00:1A:2B:3C:4D:6A',
    macWired: '00:1A:2B:3C:4D:6B',
    lastBootTime: '2024-01-25 08:20:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-02-05 11:30:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-12 16:00:00',
    updatedBy: '赵运维',
    currentUser: '钱十一',
    lastUser: '孙十二',
    currentHost: {
      id: 'PC005',
      name: '云电脑-005'
    }
  },
  {
    id: 'TC008',
    alias: '工位-C02',
    serialNumber: 'SN20240008',
    status: 'enabled',
    venue: '成都分公司',
    venueId: 'VEN005',
    tenant: '互联网科技',
    tenantId: 'TEN002',
    macWireless: '00:1A:2B:3C:4D:6C',
    macWired: '00:1A:2B:3C:4D:6D',
    lastBootTime: '2024-01-25 08:25:00',
    firmwareVersion: 'v2.3.0',
    createdAt: '2024-02-05 11:35:00',
    createdBy: '王管理员',
    updatedAt: '2024-02-12 16:05:00',
    updatedBy: '赵运维',
    lastUser: '李十三'
  },
  {
    id: 'TC009',
    alias: '会议室-02',
    serialNumber: 'SN20240009',
    status: 'enabled',
    venue: '广州办公区',
    venueId: 'VEN006',
    tenant: '云计算服务',
    tenantId: 'TEN003',
    macWireless: '00:1A:2B:3C:4D:6E',
    macWired: '00:1A:2B:3C:4D:6F',
    lastBootTime: '2024-01-25 08:10:00',
    firmwareVersion: 'v2.3.1',
    createdAt: '2024-01-20 13:00:00',
    createdBy: '刘管理员',
    updatedAt: '2024-01-26 11:20:00',
    updatedBy: '陈运维',
    currentUser: '周十四',
    currentHost: {
      id: 'PC006',
      name: '云电脑-006'
    }
  },
  {
    id: 'TC010',
    alias: '工位-D01',
    serialNumber: 'SN20240010',
    status: 'disabled',
    venue: '广州办公区',
    venueId: 'VEN006',
    tenant: '云计算服务',
    tenantId: 'TEN003',
    macWireless: '00:1A:2B:3C:4D:70',
    macWired: '00:1A:2B:3C:4D:71',
    lastBootTime: '2024-01-24 17:30:00',
    firmwareVersion: 'v2.3.0',
    createdAt: '2024-01-20 13:05:00',
    createdBy: '刘管理员',
    updatedAt: '2024-01-26 11:25:00',
    updatedBy: '陈运维',
    lastUser: '吴十五'
  }
];

export const mockTenants = [
  { id: 'TEN001', name: '科技有限公司' },
  { id: 'TEN002', name: '互联网科技' },
  { id: 'TEN003', name: '云计算服务' },
  { id: 'TEN004', name: '数据科技' },
  { id: 'TEN005', name: '智能科技' }
];

export const mockVenues = [
  { id: 'VEN001', name: '北京总部办公区', tenantId: 'TEN001' },
  { id: 'VEN002', name: '上海分公司', tenantId: 'TEN002' },
  { id: 'VEN003', name: '深圳研发中心', tenantId: 'TEN001' },
  { id: 'VEN004', name: '杭州办事处', tenantId: 'TEN003' },
  { id: 'VEN005', name: '成都分公司', tenantId: 'TEN002' },
  { id: 'VEN006', name: '广州办公区', tenantId: 'TEN003' }
];
